import type { CapabilityRegistry } from '@trimble/web3d';
import { ViewModeCapabilityCoordinator } from './view-mode-capability-coordinator';

/**
 * Determines if a pane is eligible for issue marker operations.
 * A pane is eligible if it's in 3D, Panorama, or Image view mode.
 */
export function isMarkerEligiblePane(
  pane: ReturnType<CapabilityRegistry['paneContainers']>[0]
): boolean {
  const viewModeType = pane
    .get(ViewModeCapabilityCoordinator)()
    ?.viewMode().type;
  return (
    viewModeType === '3D' ||
    viewModeType === 'Panorama' ||
    viewModeType === 'Image'
  );
}

export function is3DPane(
  pane: ReturnType<CapabilityRegistry['paneContainers']>[0]
): boolean {
  const viewModeCoord = pane.get(ViewModeCapabilityCoordinator)();
  return !viewModeCoord || viewModeCoord.viewMode().type === '3D';
}
